import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Phone } from "lucide-react";

export default function FloatingCallButton() {
  const [phone, setPhone] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setPhone(r.data?.primary_phone || "")).catch(() => {});
  }, []);

  if (!phone) return null;

  return (
    <div className="fixed bottom-5 left-5 z-[60]" data-testid="floating-call">
      {open ? (
        <div className="bg-white shadow-lg border border-neutral-200 rounded-md p-4 w-72 fade-in">
          <p className="label-eyebrow mb-1">Speak with us</p>
          <p className="font-serif-display text-xl text-[#1a1a1a] mb-3 leading-tight">We're here to listen.</p>
          <a href={`tel:${phone.replace(/[^0-9+]/g, "")}`} className="btn-primary-burgundy w-full justify-center" data-testid="floating-call-link">
            <Phone size={14} /> Call {phone}
          </a>
          <button onClick={() => setOpen(false)} className="block mt-3 text-xs text-neutral-500 hover:text-[#6B1F2A] mx-auto">
            Close
          </button>
        </div>
      ) : (
        <button
          onClick={() => setOpen(true)}
          className="bg-[#6B1F2A] hover:bg-[#8A2B3A] text-white rounded-full shadow-lg w-14 h-14 flex items-center justify-center transition-colors"
          aria-label="Call us"
          data-testid="floating-call-toggle"
        >
          <Phone size={20} />
        </button>
      )}
    </div>
  );
}
